import { PageId, WorkflowIdEnum } from '../../api/useWorkflowDataQuery';

export interface StepInfo {
  label: string;
  navigateTo: PageId;
  pages: PageId[];
}

const COMPREHENSIVE_STEPS: StepInfo[] = [
  {
    label: 'General',
    navigateTo: PageId.PersonalInfo,
    pages: [PageId.InviteClient, PageId.PersonalInfo, PageId.Goals],
  },
  {
    label: 'Accounts',
    navigateTo: PageId.Accounts,
    pages: [
      PageId.Accounts,
      PageId.ManageLinks,
      PageId.OtherAssets,
      PageId.StockOptions,
      PageId.Insurance,
    ],
  },
  { label: 'Income', navigateTo: PageId.Income, pages: [PageId.Income] },
  { label: 'Expenses', navigateTo: PageId.Expenses, pages: [PageId.Expenses] },
  {
    label: 'Advanced',
    navigateTo: PageId.RiskTolerance,
    pages: [PageId.RiskTolerance, PageId.TaxFiling, PageId.DocumentVault],
  },
];

export const getSteps = (workflowId: WorkflowIdEnum): StepInfo[] => {
  switch (workflowId) {
    case WorkflowIdEnum.Comprehensive:
      return COMPREHENSIVE_STEPS;
    case WorkflowIdEnum.AssetBucketing:
      return COMPREHENSIVE_STEPS.filter(step => step.label !== 'Advanced');
    case WorkflowIdEnum.EstatePlanning:
      return [
        {
          label: 'General',
          navigateTo: PageId.EstatePlanningPersonalInfo,
          pages: [PageId.InviteClient, PageId.EstatePlanningPersonalInfo],
        },
        {
          label: 'Accounts',
          navigateTo: PageId.Accounts,
          pages: [PageId.Accounts, PageId.ManageLinks],
        },
        { label: 'Assets', navigateTo: PageId.OtherAssets, pages: [PageId.OtherAssets] },
        { label: 'Insurance', navigateTo: PageId.Insurance, pages: [PageId.Insurance] },
        {
          label: 'Review',
          navigateTo: PageId.EstatePlanningWorkflowReview,
          pages: [PageId.EstatePlanningWorkflowReview],
        },
      ];
    default:
      throw new Error(`Unknown workflowId: ${workflowId}`);
  }
};
